import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ac66020e")

_pushScopeId("data-v-ac66020e")
const _hoisted_1 = { class: "relative inline-block" }
const _hoisted_2 = {
  key: 0,
  class: "absolute left-0 mt-1 w-full min-w-[180px] bg-white border border-gray-lp-400 rounded-md shadow-lg z-50 py-2"
}
const _hoisted_3 = {
  key: 0,
  class: "px-4 py-2 text-black-lp-100 font-bold text-12px xxl:text-14px"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_LpButton, {
      color: _ctx.isActive ? 'red-lp-100' : 'gray-lp-400',
      textColor: _ctx.isActive ? 'red-lp-100' : 'black-lp-100',
      iconColor: _ctx.isActive ? 'red-lp-100' : 'black-lp-100',
      outline: "",
      title: _ctx.selectedLabel,
      iconLeft: _ctx.iconLeft,
      iconV2: !!_ctx.iconLeft,
      isWidthFull: "",
      onClick: _ctx.toggleDropdown
    }, null, 8, ["color", "textColor", "iconColor", "title", "iconLeft", "iconV2", "onClick"]),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.dropdownTitle)
            ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.dropdownTitle), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createBlock("div", {
              key: option.value,
              class: ["px-4 py-2 hover:bg-gray-lp-1500 cursor-pointer text-12px xxl:text-14px", 
          _ctx.modelValue === option.value
            ? 'text-red-lp-100 font-semibold'
            : 'text-black-lp-300'
        ],
              onClick: ($event: any) => (_ctx.selectOption(option))
            }, _toDisplayString(option.name), 11, ["onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, () => (_ctx.isOpen = false)]
  ])
})